import ticketsApi from 'api/requests/tickets';
import Text from 'components/_UI/Text';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import ProductSelect from './ProductSelect';
import Loader from 'components/_UI/Loader';
import breakpoints from 'theme/breakpoints';
import Button from 'components/_UI/Button';
import { useEvent } from 'context/events/Event';
import { SaleTypes } from 'modules/_common/SaleTypes';
import { Row } from 'styled/alignment/Row';

export default function ProductsToEvent({
    edit,
    availableProducts,
    isDraft,
    onSuccess = () => false,
    goBackFormStep = () => false,
}) {
    const [loading, setLoading] = useState(false);
    const [selectedProductIds, setSelectedProductIds] = useState([]);
    const [products, setProducts] = useState([]);

    const { event } = useEvent();

    useEffect(() => {
        getProducts();
    }, [event]);

    const getProducts = () => {
        setProducts(availableProducts);

        if (edit && event?.products?.length) {
            const preSelectedProductIds = event.products.map(product => product.name);
            setSelectedProductIds(preSelectedProductIds);
        }
    };

    const handleSelect = (id) => {
        setSelectedProductIds((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter(productId => productId !== id)
                : [...prevSelected, id]
        );
    };

    const handleUpdateProduct = (id, updatedValues) => {
        setProducts((prevProducts) =>
            prevProducts.map(product =>
                product.id === id ? { ...product, ...updatedValues } : product
            )
        );
    };

    const handlePayload = () => {
        const payload = products
            .filter(product => selectedProductIds.includes(product.name))
            .map(product => {
                const payload = {
                    event_id: event?.id,
                    price: parseFloat(product.price),
                    name: product.name,
                    quantity: product.quantity,
                    description: product?.description,
                    type: 'product',
                    image_id: product.image_id,
                    sale_type: SaleTypes.BATCH
                }

                if (edit) {
                    const selected = event?.products?.find(el => el.name === product.name);

                    if (selected) {
                        payload.id = selected.id
                        payload.batches = [{
                            id: selected.batches[0].id,
                            is_active: selected.batches[0].is_active,
                            price: parseFloat(product.price),
                            name: product.name,
                            quantity: product.quantity,
                            description: product?.description,
                        }]
                    }
                }

                if (!payload?.image_id) {
                    delete payload.image_id;
                }

                return payload
            });

        if (!payload?.description) {
            delete payload.description;
        }

        if (!payload?.image_id) {
            delete payload.image_id;
        }

        const formatedPayload = payload.map(el => {
            let item = el;
            if (!item.description) {
                delete item.description
            }

            return item
        })

        return formatedPayload
    };

    async function updateProducts() {
        const payload = {
            type: 'products',
            event_id: event?.id,
            products: handlePayload()
        };

        setLoading(true);

        try {
            const { data } = await ticketsApi.updateBulk(payload);
            onSuccess({
                ...event,
                ...data,
            })
        } catch (error) {
            // console.log('error')
        } finally {
            setLoading(false);
        }
    }

    async function createProducts() {
        const payload = {
            products: handlePayload()
        };

        setLoading(true);

        if (!payload?.products?.length) {
            onSuccess(event);

            if (!isDraft) {
                removeDraft();
            }
            return
        }

        try {
            const { data } = await ticketsApi.createBulk(payload);
            onSuccess({
                ...event,
                ...data,
            })

            if (!isDraft) {
                removeDraft();
            }
        } catch (error) {
            // console.log('error')
            setLoading(false);
        }
    }

    async function removeDraft() {
        try {
            await ticketsApi.removeDraft(event?.slug);
        } catch (error) {
            // console.log('error')
        } finally {
            setLoading(false);
        }
    }

    function getSelectedProduct(name) {
        if (!selectedProductIds.includes(name)) {
            return null;
        }

        const product = event?.products?.find(p => p.name === name);

        if (!product) {
            return availableProducts.find(p => p.name === name);
        }

        return product?.batches?.[0];
    }



    return (
        <Container>
            <FullyCentered>
                <Text name='title' color={colors.occasionalPurple}>
                    Selecione os produtos do evento
                </Text>
            </FullyCentered>

            {
                loading ? (
                    <FullyCentered>
                        <Loader />
                    </FullyCentered>
                ) : (
                    <ProductsList>
                        {
                            availableProducts?.map(el => (
                                <ProductSelect
                                    data={el}
                                    key={el.id}
                                    edit={edit}
                                    selected={getSelectedProduct(el.name)}
                                    products={event?.products}
                                    onSelect={() => handleSelect(el.name)}
                                    onUpdate={handleUpdateProduct}
                                />
                            ))
                        }
                    </ProductsList>
                )}

            <ButtonsContainer>
                {
                    loading ? (
                        <FullyCentered>
                            <Loader />
                        </FullyCentered>
                    ) : (
                        <ButtonsContent>
                            <Column width='280px'>
                                <Button variant='secondary' onClick={() => goBackFormStep(2)}>
                                    Voltar
                                </Button>
                            </Column>
                            <Column width='280px'>
                                <Button onClick={!edit ? createProducts : updateProducts}>
                                    Avançar
                                </Button>
                            </Column>
                        </ButtonsContent>
                    )
                }
            </ButtonsContainer >
        </Container >
    );
}

const Container = styled(Column)`
    overflow-x: auto;
    padding-bottom: 100px;
`

const ProductsList = styled(Column)`
    margin-top: 30px;
    
    @media screen and (min-width: ${breakpoints.md}){
        flex-direction: row;
        flex-wrap: wrap;

        & > div {
            width: 31.5%;
            margin-left: 1%;

            &:first-child {
                margin-left: 0;
            }
        }
       
    }
`;

const ButtonsContainer = styled(FullyCentered)`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-bottom: 14px;
    background: ${colors.neutralLight};
    border-top: 1px solid ${colors.nightLight};
    border-radius: 12px;
    box-shadow: 0 -2px 8px #ddd;
    z-index: 99;

    @media screen and (min-width: ${breakpoints.md}) {
        width: 75%;
    }
   
`;


const ButtonsContent = styled(Row)`
    margin-top: 40px;
    justify-content: center;
    gap: 8px;
`